import { useGetOnePortfolio } from '@netpurpose/api'
import { useLoggedIn } from '@netpurpose/core'
import { useLocalStorage } from 'usehooks-ts'
import { config } from '#services/config'

type RecentPortfolio = { id: number; name: string }

// The Report page isn't a fixed route - it lands on the most recently viewed
// portfolio (or, failing that, the user's first portfolio). This hook centralises
// that logic so both the side nav link and the post-login redirect agree on where
// "Report" points.
export const useReportUrl = () => {
  const { user } = useLoggedIn()
  const [viewedPortfolios] = useLocalStorage(
    `${config.localStorageKeys.lastViewedPortfolios(user?.getGroupIds()?.[0] || '')}`,
    '[]',
  )
  const recentPortfolios = JSON.parse(viewedPortfolios) as RecentPortfolio[]

  const { portfolio, isPending } = useGetOnePortfolio()

  const latestViewedId = recentPortfolios[0]?.id
  const portfolioId = latestViewedId ?? portfolio?.id

  return {
    recentPortfolios,
    reportUrl: portfolioId
      ? config.dynamicRoutes.portfolioDetail(portfolioId)
      : config.routes.portfolioList,
    // Only wait on the query when there's no recently viewed portfolio to fall back
    // on, and until the user (and so their group's stored portfolios) has loaded.
    isLoading: !user || (latestViewedId === undefined && isPending),
  }
}
